module.exports = __webpack_public_path__ + "static/media/MikeRussell.66edce66.png";